import { z } from "zod";
import { createCodec } from "../codec";

const AddressApiSchema = z.object({
  id: z.number().optional(),
  address_line_1: z.string(),
  address_line_2: z.string(),
  city: z.string(),
  state: z.string(),
  zip_code: z.string(),
  country: z.string(),
});

const AddressCodec = createCodec({
  apiSchema: AddressApiSchema,
  deserialize: (api) => ({
    id: api.id,
    addressLine1: api.address_line_1,
    addressLine2: api.address_line_2,
    city: api.city,
    state: api.state,
    zipCode: api.zip_code,
    country: api.country,
  }),
  serialize: (app) => ({
    id: app.id,
    address_line_1: app.addressLine1,
    address_line_2: app.addressLine2,
    city: app.city,
    state: app.state,
    zip_code: app.zipCode,
    country: app.country,
  }),
});

type Address = z.output<typeof AddressCodec.schema>;
type AddressApi = z.input<typeof AddressCodec.schema>;

export { AddressCodec, type Address, type AddressApi };
